import React from "react";
import { Stack, StackProps } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

type StoreContainerProps = StackProps;

export const StoreContainer = ({
  className,
  children,
  ...props
}: StoreContainerProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <Stack
      sx={{
        border: "1px solid",
        borderColor: colors.outline.outline,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: colors.surface.surface,
        width: "200px",
        height: "55px",
        borderRadius: "0.5rem",
      }}
      className={className}
      {...props}
    >
      {children}
    </Stack>
  );
};
